"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
var react_1 = __importStar(require("react"));
var mapbox_gl_1 = __importDefault(require("mapbox-gl"));
var MapBox = function (props) {
    var _a = react_1.useState(null), map = _a[0], setMap = _a[1];
    var _b = react_1.useState(true), shouldInitMap = _b[0], setShouldInitMap = _b[1];
    var mapContainer = react_1.useRef(null);
    var height = props.height, center = props.center, zoom = props.zoom, sources = props.sources, style = props.style, accessToken = props.accessToken, images = props.images;
    react_1.useEffect(function () {
        console.log("setShouldInitMap", true);
        setShouldInitMap(true);
    }, [sources, images, center]);
    react_1.useEffect(function () {
        // @ts-ignore
        mapbox_gl_1.default.accessToken = accessToken;
        // @ts-ignore
        var initializeMap = function (_a) {
            var setMap = _a.setMap, mapContainer = _a.mapContainer;
            console.log("initializeMap", sources);
            setShouldInitMap(false);
            var map = new mapbox_gl_1.default.Map({
                container: mapContainer.current,
                style: style,
                center: [center.longitude, center.latitude],
                zoom: zoom
            });
            map.on("load", function () {
                setMap(map);
                map.resize();
                images === null || images === void 0 ? void 0 : images.forEach(function (_a) {
                    var name = _a.name, image = _a.image, external = _a.external;
                    if (external) {
                        map.loadImage(image.toString(), function (error, img) {
                            // @ts-ignore
                            map.addImage(name, img);
                        });
                    }
                    else {
                        map.addImage(name, image);
                    }
                });
                sources === null || sources === void 0 ? void 0 : sources.forEach(function (_a) {
                    var source = _a.source, layers = _a.layers, sourceId = _a.sourceId;
                    map.addSource(sourceId, source);
                    layers.forEach(function (_a) {
                        var data = _a.data, onClick = _a.onClick, onMouseEnter = _a.onMouseEnter, onMouseLeave = _a.onMouseLeave;
                        map.addLayer(data);
                        if (onClick) {
                            map.on("click", data.id, function (e) {
                                onClick(e, map);
                            });
                        }
                        if (onMouseEnter) {
                            map.on("mouseenter", data.id, function (e) {
                                onMouseEnter(e, map);
                            });
                        }
                        if (onMouseLeave) {
                            map.on("mouseleave", data.id, function (e) {
                                onMouseLeave(e, map);
                            });
                        }
                    });
                });
            });
        };
        if (shouldInitMap)
            initializeMap({ setMap: setMap, mapContainer: mapContainer });
    }, [map]);
    // @ts-ignore
    return react_1.default.createElement("div", { ref: function (el) { return (mapContainer.current = el); }, style: { height: height } });
};
MapBox.defaultProps = {
    center: {
        longitude: 10.2128,
        latitude: 56.1523
    },
    zoom: 10,
    height: 500,
    accessToken: "pk.eyJ1Ijoia3NhaWVkIiwiYSI6ImNqemRzZGFtbDAwb2YzaW1oYWhjbmZqOHAifQ.FIUeHT0EcfjhHqwcFf0CvA",
    style: "mapbox://styles/ksaied/ckn5tmjzv0w2a18mq6elyfe04"
};
exports.default = MapBox;
